import api from "./api";
import { downloadApiCsv } from "./downloadCsv";

const qs = (p) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null)
);

const estoqueService = {
  meta: (p = {}) => api("GET", `/estoque/meta?${qs(p)}`),
  resumo: (idCondominio) => api("GET", `/estoque/resumo?${qs({ idCondominio })}`),
  abaixoMinimo: (idCondominio) => api("GET", `/estoque/relatorios/abaixo-minimo?${qs({ idCondominio })}`),
  relatorioReposicao: (p = {}) => api("GET", `/estoque/relatorios/reposicao?${qs(p)}`),
  relatorioPosicao: (p = {}) => api("GET", `/estoque/relatorios/posicao?${qs(p)}`),
  exportReposicaoCsv: (p = {}) => downloadApiCsv(`/estoque/relatorios/reposicao?${qs({ ...p, formato: "csv" })}`),
  exportPosicaoCsv: (p = {}) => downloadApiCsv(`/estoque/relatorios/posicao?${qs({ ...p, formato: "csv" })}`),

  listarLocais: (p = {}) => api("GET", `/estoque/locais?${qs(p)}`),
  criarLocal: (data) => api("POST", "/estoque/locais", data),
  atualizarLocal: (id, data) => api("PUT", `/estoque/locais/${id}`, data),

  listarUnidadesMedida: (p = {}) => api("GET", `/estoque/unidades-medida?${qs(p)}`),
  criarUnidadeMedida: (data) => api("POST", "/estoque/unidades-medida", data),
  atualizarUnidadeMedida: (id, data) => api("PUT", `/estoque/unidades-medida/${id}`, data),
  converterUnidade: (data) => api("POST", "/estoque/unidades-medida/converter", data),

  listarItens: (p = {}) => api("GET", `/estoque/itens?${qs(p)}`),
  criarItem: (data) => api("POST", "/estoque/itens", data),
  atualizarItem: (id, data) => api("PUT", `/estoque/itens/${id}`, data),

  listarMovimentacoes: (p = {}) => api("GET", `/estoque/movimentacoes?${qs(p)}`),
  criarMovimentacao: (data) => api("POST", "/estoque/movimentacoes", data),

  listarKits: (p = {}) => api("GET", `/estoque/kits?${qs(p)}`),
  buscarKit: (id) => api("GET", `/estoque/kits/${id}`),
  criarKit: (data) => api("POST", "/estoque/kits", data),
  atualizarKit: (id, data) => api("PUT", `/estoque/kits/${id}`, data),
  aplicarKit: (id, data) => api("POST", `/estoque/kits/${id}/aplicar`, data),
};

export default estoqueService;
